import React from "react";

import { KINDS, SIZES } from "../buttons/buttons.constants";
import LinkButton from "../buttons/link-button";
import styles from "./error.module.scss";

interface Props {
    heading: string;
    subHeading: string;
    ctaLabel: string;
    ctaUrl: string;
}
const Error: React.FC<Props> = ({ heading, subHeading, ctaLabel, ctaUrl }) => {
    return (
        <div className={styles.container}>
            <h1 className={styles.heading}>{heading}</h1>
            <p className={styles.subHeading}>{subHeading}</p>
            <div className={styles.buttonContainer}>
                <LinkButton
                    disabled={false}
                    fluid={false}
                    kind={KINDS.PRIMARY}
                    size={SIZES.LARGE}
                    label={ctaLabel}
                    url={ctaUrl}
                    newTab={false}
                    show
                />
            </div>
        </div>
    );
};

export default Error;
